import { createReducer, on } from '@ngrx/store';
import * as UserDetailsActions from './user-details.actions';
import { initialUserDetailsState } from './user-details.state';

export const userDetailsReducer = createReducer(
  initialUserDetailsState,
  on(UserDetailsActions.setUserDetailsData, (state, { data }) => ({
    ...state,
    ...data,
  })),
  on(UserDetailsActions.clearUserDetailsData, (state) => ({
    ...state,
    ...initialUserDetailsState,
  }))
);
